export default {
  methods: {
    getMonthDate() {
      let stCreateDttm = this.$moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
      let edCreateDttm = this.$moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
      return {stCreateDttm: stCreateDttm, edCreateDttm: edCreateDttm};
    },
    getStMonthDate() {
      return this.$moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
    },
    getEdMonthDate() {
      return this.$moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/date.js